/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: mutations.ts
 * Class: mutations.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { MutationTree } from 'vuex';
import { ProductResponse, ProductState } from './types';
import { getDefaultErrorState, getDefaultLoadingState, getDefaultState } from '@a/store/utils';
import { MutationRequestStatus } from '@a/store/types';

export const mutations: MutationTree<ProductState> = {
  orderProductLoading: (state) => {
    state.orderProduct = { ...getDefaultLoadingState() };
  },
  orderProductLoaded: (state, payload: ProductResponse) => {
    state.orderProduct = {
      data: payload,
      status: MutationRequestStatus.SUCCESS,
      error: undefined,
    };
  },
  orderProductFailure: (state) => {
    state.orderProduct = { ...getDefaultErrorState() };
  },
};
